module.exports = __webpack_public_path__ + "img/17.543a6f01.jpg";